module.exports = __webpack_public_path__ + "img/google.29bf3c0d.svg";